import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function AuFaq() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerbackup');

    const lists = [
        { title: t('faq_q1'), desc: t('faq_a1') },
        { title: t('faq_q2'), desc: t('faq_a2') },
        { title: t('faq_q3'), desc: t('faq_a3') },
        { title: t('faq_q4'), desc: t('faq_a4') },
        { title: t('faq_q5'), desc: t('faq_a5') },
        { title: t('faq_q6'), desc: t('faq_a6') },
    ];

    return (
        <div
            id="power-backup-au-faq"
            className={`power-backup-au-faq ${css['power-backup-au-faq']} GtmModuleData-section`}
            data-section-id="power-backup-au-faq"
            data-section-title={t('faq_title')}
        >
            <div className="power-backup-title">{t('faq_title')}</div>
            <div className="collapse-box">
                <Collapse
                    ghost
                    className="collapse-lists"
                    defaultActiveKey={0}
                    expandIcon={({ isActive }: { isActive?: boolean }) => (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                    expandIconPosition="right"
                >
                    {lists.map((list, k) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}
